var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-button-container"},[_c('navbar-button',{on:{"click":_vm.showCalendar}},[_c('i',{staticClass:"el-icon-timer",staticStyle:{"width":"28px, height: 28px"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }